<template>
  <div>
    <div class="form-group">
      <label for="offer">Offer (example: @marketing/offer/golden_box)</label>
      <input v-model="offerIdStr" id="offer" class="form-control" required>
    </div>

    <div class="form-group">
      <label for="action-selector">Action</label>
      <b-form-select
        id="action-selector"
        v-model="action"
        :options="actionOptions"
      />
    </div>
  </div>
</template>

<script>
const ACTION_START  = 1;
const ACTION_FINISH = 2;

export default {
  name: 'PlayerPendingAddDataInputForceSpecialOffer',

  data() {
    return {
      offerIdStr: '',
      action: ACTION_START,
    };
  },

  computed: {
    actionOptions() {
      return [
        {
          value: ACTION_START,
          text: 'start',
        },
        {
          value: ACTION_FINISH,
          text: 'finish',
        },
      ];
    },
  },

  methods: {
    fillFormData(formData) {
      const trimmedOfferIdStr = this.offerIdStr.trim();
      if(trimmedOfferIdStr.length === 0) {
        return new Error('Offer must be specified.');
      }

      formData.append('offer_id_str', trimmedOfferIdStr);
      formData.append('action',       this.action);

      return null;
    },
  },
}
</script>
